import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { useAskInputOverLimitWarningPlugin } from '#pplx/frontend/apps/ask/composer-ui/useAskInputOverLimitWarningPlugin.js';
import { usePerplexityQueryState } from '#pplx/frontend/apps/ask/providers/ask-query-state-provider/hooks/usePerplexityQueryState.js';
import { invariant } from '#pplx/frontend/common/invariant.js';
import { createQuotePluginFactory } from '#pplx/frontend/composer-sdk-plugins/quote/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { createElement, useCallback, useEffect, useMemo } from 'react';
const createQuotePlugin = createQuotePluginFactory();
export function useHomeComposerInputHeaderPlugins({ composerRef, characterCount, }) {
    const { quote, setQuote } = usePerplexityQueryState();
    const overLimitPlugin = useAskInputOverLimitWarningPlugin({ count: characterCount });
    const onClose = useCallback(() => {
        setQuote(null);
        invariant(composerRef.current !== null, 'Home Composer handle is required');
        composerRef.current.focus();
    }, [composerRef, setQuote]);
    useEffect(() => {
        if (quote === null || quote.length === 0)
            return;
        // Home has no follow-up selections, so the legacy followUps.selections focus skip does not apply.
        invariant(composerRef.current !== null, 'Home Composer handle is required');
        composerRef.current.focus();
    }, [composerRef, quote]);
    const quotePlugin = useMemo(() => createQuotePlugin({
        message: quote ?? '',
        leadingAccessory: createElement(Icon, { icon: $icon('quote-filled') }),
        onClose,
    }), [onClose, quote]);
    return useMemo(() => [overLimitPlugin, quotePlugin], [overLimitPlugin, quotePlugin]);
}
//# sourceMappingURL=useHomeComposerInputHeaderPlugins.js.map